<template>
  <div>
    <!-- Filters -->
    <!--
    <Orders-list-filters
      :role-filter.sync="roleFilter"
      :plan-filter.sync="planFilter"
      :status-filter.sync="statusFilter"
      :role-options="roleOptions"
      :plan-options="planOptions"
      :status-options="statusOptions"
    />-->

      <!-- Table Container Card -->

    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row class="justify-content-between align-items-center">

          <!-- Per Page -->
          <b-col
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0" :md="4"
          >
            <label>Gösterim Sayısı</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>sonuç</label>
          </b-col>
          <b-col :md="4" v-if="title">
            <b-card-title class="justify-content-center mb-0 text-center">
              {{ title }}
            </b-card-title>
          </b-col>
          <b-col class="d-flex align-items-center justify-content-end" v-if="$route.name=='orders' && !isFenomen" :md="4">
            <div class="mr-2 d-none">Kalan Süre <span v-html="orderStatus.getRemainingTime"></span></div>
            <b-button :disabled="orderStatus.loading" variant="success" @click="updateOrderStatus">
              {{ orderStatus.loading ? 'Yükleniyor...' : 'Manuel Durum Güncelle' }}
            </b-button>
          </b-col>

          
           <!-- Payment Status -->
          <b-col v-else :md="4">
            <div class="d-flex align-items-center justify-content-end">
              <v-select
                v-model="statusFilter"
                :options="statusOptions"
                :reduce="val => val.id"
                label="label"
                class="invoice-filter-select custom-vue-select"
                placeholder="Ödeme Durumu"
              >
              </v-select>
            </div>
          </b-col>
          
        </b-row>

      </div>
      <b-table
        ref="refOrderListTable"
        class="position-relative"
        :items="orderData"
        responsive
        :fields="resolvedTableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="Sipariş Bulunamadı"
        :sort-desc.sync="isSortDirDesc"
         :tbody-tr-class="rowClass"
      >
      <template #head(id) v-if="checkPayment && !isFenomen">
        <b-form-checkbox v-model="selectAll" @change="toggleAllSelections">
          ID
        </b-form-checkbox>
      </template>
      
      <template #cell(id)="data" v-if="checkPayment && !isFenomen">
        <b-form-checkbox v-if="!data.item.payment_status"
          v-model="data.item.selected"  
          @change="updateSelection(data.item.id, data.item.selected)"  
        >
          {{ data.item.id }}
        </b-form-checkbox>
        <span v-else>{{ data.item.id }}</span>
      </template>

      
      <template #cell(influencer)="data">
        <template v-if="data.item.influencer && data.item.influencer.id">
          <influencer-link-btn :id="data.item.influencer.id" :name="data.item.influencer.username" />
        </template>
        <template v-else>
          <p>Bilinmeyen Fenomen</p>
        </template>
      </template>

      <template #cell(link)="data">
        <template v-if="data.item.link && data.item.link.id">
          <campaign-link-btn :name="data.item.link.campaign_name" :route="getLinkName(data.item.link)" />
        </template>
        <template v-else>
          <p>Bilinmeyen Paylaşım</p>
        </template>
      </template>

      <template #head(inf_payment_total)="data">
        <div class="text-right">{{ data.field.label }}</div>
      </template>

      <template #cell(inf_payment_total)="data">
        <div class="text-right" v-if="data.item.influencer.id!=1"> 
          <b-badge variant="light-danger" v-if="data.item.inf_payment_total==null">
            Hesaplanıyor...
          </b-badge>
          <span v-else>{{ priceFormat(data.item.inf_payment_total) }}</span>
        </div>
      </template>
      
      <template #head(amount)="data">
        <div class="text-right">{{ data.field.label }}</div>
      </template>

      <template #cell(amount)="data">
        <div class="text-right">{{ priceFormat(data.item.amount) }}</div>
      </template>

      <template #cell(vesting_status)="data">
        <div v-if="data.item.influencer.id!=1">
          <b-badge variant="light-danger" v-if="data.item.order_status_id==9">
            YOK
          </b-badge>
          <b-badge
            pill
            :variant="'light-success'"
            class="text-capitalize"
            v-else-if="data.item.vesting_status"
          >
            Hak edildi
          </b-badge>
          <b-badge
            pill
            :variant="'light-warning'"
            class="text-capitalize"
            v-else
          >
            {{ vestingDay(data.item.created_date, data.item.influencer.vesting_period, data.item.order_status_id) }}
          </b-badge>
        </div>
      </template>
      
    <template #cell(platform)="data">
        <b> {{ data.item.platform.name }}</b> 
    </template>

      <template #cell(type)="data">
          <b> {{ getTypeName(data.item.link.type) }}</b> 
      </template>

      <template #cell(show_details)="data">
      <!-- Gizli checkbox (BootstrapVue'nun row details için gerekli) -->
      <b-form-checkbox
        v-model="data.detailsShowing"
        @change="handleToggle(data)"
        style="display: none;"
      ></b-form-checkbox>

      <!-- Kullanıcının tıklayacağı ikon -->
      <div @click="handleToggle(data)" style="cursor: pointer;">
        <FeatherIcon icon="ChevronUpIcon" v-if="data.detailsShowing" />
        <FeatherIcon icon="ChevronDownIcon" v-else />
      </div>
    </template>

      <!-- full detail on click -->
      <template #row-details="data">
      <b-card class="border border-primary pb-0">

        <!-- <b-card-body harici bilgilere gerek yok.
          class="invoice-padding pt-0"
        >
          <b-row class="invoice-spacing">
            
            <b-col
              xl="6"
              cols="12"
            >
              <div>
                <h6 class="mb-2">
                  Ödeme Detayları:
                </h6>
                <p>
                  <b>Sipariş Numarası:</b>
                  <span>{{ data.item.transaction }}</span>
                </p>
                <p>
                  <b>Ödeme Türü:</b>
                  <span>{{ data.item.payment_name }}</span>
                </p>
                <p>
                  <b>Ülke:</b>
                  <span>{{ data.item.country }}</span>
                </p>
                <p>
                  <b>Kargo Ücreti:</b>
                  <span>{{ data.item.cargo_price }}</span>
                </p>
                <p>
                  <b>Toplam Tutar:</b>
                  <span class="font-weight-bold">{{ data.item.amount }} {{ data.item.currency }}</span>
                </p>
              </div>
            </b-col>

            <b-col
              cols="12"
              xl="6"
              class="p-0"
              v-if="data.item.delivery_address"
            >
              <h6 class="mb-2">
                Fatura Alıcısı:
              </h6>
              <h6 class="mb-25">
                {{ data.item.delivery_address.firstName }} {{ data.item.delivery_address.lastName }}
              </h6>
              <p class="card-text mb-25">
                {{ data.item.delivery_address.address }},
              </p>
              <p class="card-text mb-25">
                {{ data.item.delivery_address.city }}, {{ data.item.delivery_address.country }}
              </p>
              <p class="card-text mb-25">
                {{ data.item.delivery_address.mobilePhone }}
              </p>
              <p class="card-text mb-0">
                {{ data.item.delivery_address.zip }}
              </p>
            </b-col>

          </b-row>
        </b-card-body> -->

        <h6 class="mb-1">
          <b class="text-danger">{{ data.item.transaction }}</b>  Sipariş numasına ait ürünler:
        </h6>
         <!-- Invoice Description: Table -->
         <b-table-lite
            v-if="data.item.products && data.item.products.length"
            responsive
            :items="data.item.products"
            :fields="[
              { key: 'identifier', label: 'ID'},
              { key: 'image', label: 'Görsel'},
              { key: 'name', label: 'Adı'},
              { key: 'category', label: 'Kategori'},
              { key: 'variant_name', label: 'Alt Ürün'},
              { key: 'quantity', label: 'Adet'},
              { key: 'total_amount', label: 'Ürün Fiyat'},
              { key: 'payment_type', label: 'Paylaşım Kaynak'},
              { key: 'payment_amount', label: 'Fenomen Ödenecek Tutar'}
            ]"
          >
          <template #cell(total_base_amount)="product">
              {{ product.item.total_base_amount }} {{ product.item.currency }}
          </template>
          
      
        <template #cell(quantity)="product">
              <b>{{ product.item.quantity }}</b> Adet
        </template>
          <template #cell(payment_type)="product" class="text-bold">
            <b-badge variant="light-danger" v-if="product.item.payment_type==null">
              Hesaplanıyor...
            </b-badge>
            <div v-else>
              <span class="text-success" v-if="product.item.payment_type === 'in_link'">Link İçi : <b>%{{ data.item.link.link_ici }}</b></span>
              <span class="text-danger" v-else>link Dışı : <b>%{{ data.item.link.link_disi }}</b></span>
            </div>  
        </template>
          <template #cell(payment_amount)="product">
              {{ product.item.payment_amount }} {{ product.item.currency }}
          </template>
          <template #cell(total_amount)="product">
              {{ product.item.total_amount }} {{ product.item.currency }}
          </template>
          <template #cell(name)="product">
              <a :href="$store.state.user.customerInfo.domain+product.item.url" target="_blank">{{ product.item.name }} </a>
          </template>
          <template #cell(image)="product">
              <img :src="product.item.image" height="100" />
          </template>
          
          </b-table-lite>
          <b v-else> Ürünler yükleniyor...</b>
        
          <!--
          <b-button
            size="sm"
            variant="outline-secondary"
            @click="data.toggleDetails"
          >
            Gizle
          </b-button>
        -->
      </b-card>
      </template>

        <!-- Column: User -->
        <template #cell(user)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                size="32"
                :src="data.item.avatar"
                :text="avatarText(data.item.fullName)"
                :variant="`light-${resolveUserRoleVariant(data.item.role)}`"
                :to="{ name: 'apps-Orders-view', params: { id: data.item.id } }"
              />
            </template>
            <b-link
              :to="{ name: 'apps-Orders-view', params: { id: data.item.id } }"
              class="font-weight-bold d-block text-nowrap"
            >
              {{ data.item.fullName }}
            </b-link>
            <small class="text-muted">@{{ data.item.username }}</small>
          </b-media>
        </template>

        <!-- Column: Role -->
        <template #cell(role)="data">
          <div class="text-nowrap">
            <feather-icon
              :icon="resolveUserRoleIcon(data.item.role)"
              size="18"
              class="mr-50"
              :class="`text-${resolveUserRoleVariant(data.item.role)}`"
            />
            <span class="align-text-top text-capitalize">{{ data.item.role }}</span>
          </div>
        </template>

        <!-- Column: Status -->
        <template #cell(order_status)="data">
          <b-badge
            pill
            :variant="`light-${resolveOrderstatusVariant(data.item.order_status_id)}`"
            class="text-capitalize"
          >
            {{ data.item.order_status }} 
          </b-badge>
        </template>
        
        <template #cell(created_date)="data">
          {{ formatDate(data.item.created_date) }}
        </template>

        <template #cell(created_time)="data">
          {{ formatDateTime(data.item.created_date) }}
        </template>
        
        <template #cell(payment_status)="data">
          <b-badge
            v-if="data.item.payment_status"
            pill
            variant="light-success"
            class="text-capitalize"
          >
            Ödendi
          </b-badge>
          <b-badge
            v-else
            pill
            variant="light-danger"
            class="text-capitalize"
          >
            Ödenmedi
          </b-badge>
        </template>

      </b-table>

      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalOrders"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
    
    <!-- Seçilen IDS ve ödeme yapma -->
    <b-toast
      v-model="showToast"
      no-auto-hide
      no-close-button
      toastClass="fixed-bottom mx-auto text-center border-primary"
    >
      <template #toast-title>
        <div class="mb-0 mt-2 d-flex flex-column w-100 align-items-center">
          <h5><strong>{{ selectedIds.length }}</strong> adet sipariş seçildi </h5>
          <h4>Ödenecek tutar : <strong class="text-danger">{{ priceFormat(selectedPaymentTotal) }} </strong> </h4>
        </div>
      </template>

      <div class="d-flex justify-content-between">
        <b-button @click="paySelectedOrders" variant="success" size="sm">Ödeme Yap</b-button>
        <b-button @click="clearSelectedId" variant="danger" size="sm">İptal</b-button>
      </div>
    </b-toast>


  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BCardTitle,
  BBadge, BDropdown, BDropdownItem, BPagination, BFormCheckbox, BTableLite, BToast
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ref, watch, computed   } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import OrdersListFilters from '@/components/order/OrdersListFilters.vue'
import useOrdersList from '@/components/order/useOrdersList'
import axiosIns from '@/axios'
import { useToast } from 'vue-toastification/composition'
import CampaignLinkBtn from '@/components/link/CampaignLinkBtn.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import InfluencerLinkBtn from '@/components/link/InfluencerLinkBtn.vue'

export default {
  components: {
    OrdersListFilters,

    BCard,
    BCardTitle,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormCheckbox,
    BTableLite,
    BToast,

    vSelect,
    CampaignLinkBtn,
    InfluencerLinkBtn
  },
  props: {
    tableColumns: {
      type: Array,
      default: null,
    },
    params: {
      type: Object,
      default: () => ({}) // Boş bir nesne
    },
    title: {
      type: String,
      default: () => ('') // Boş bir nesne
    },
    checkPayment: {
      type: Boolean,
      default: () => (false) 
    }
  },
  methods: {
    async handleToggle(data) {
      // details kapalı → açılıyor
      if (!data.detailsShowing) {
        // Ürünler daha önce yüklenmediyse isteği yap
        if (!data.item.products) {
          try {
            const res = await this.$http.get(`/order/products`, {
              params: { order_id: data.item.id }
            })
            // Dönen ürünleri sipariş kaydına ekle
            this.$set(data.item, 'products', res.data.products)
          } catch (e) {
            console.error('Ürün bilgisi alınamadı:', e)
            this.$set(data.item, 'products', [])
          }
        }
      }
      // BootstrapVue’nun kendi detay toggle fonksiyonunu çağır
      data.toggleDetails()
    },
    getLinkName(item) {
      let route = {
        name: '',
        params: {
          id: item.id
        }
      };

      if (item.type == 0) {
        if (item.links && item.links.length > 0) {
          route.name = "campaign-group-detail";
          route.params.id = item.group_id;
        } else {
          route.name = "campaign-detail";
        }
      } else if (item.type == 1) {
        route.name = "story-detail";
      } else if (item.type == 2) {
        route.name = "sms-detail";
      } else if (item.type == 4) {
        route.name = "whatsapp-detail";
      } else if (item.type == 3) {
        route.name = "bio-detail";
        route.params.platform_id = item.platform.id;
      }

      return route;
    },
    isGroupItem(item){
      return item.links && item.links.length > 0
    },
    getTypeName(type) {
      switch(type) {
        case 0:
          return 'Link Paylaşımı';
        case 1:
          return 'Story Paylaşımı';
        case 2:
          return 'BSMS Paylaşımı';
        case 3:
          return 'Bio Paylaşımı';
        case 4:
          return 'Whatsapp Paylaşımı';
        default:
          return 'Bilinmeyen Tür';
      }
    }
  },
  setup(props, { emit }) {

    const toast = useToast()

    const showToast = computed(() => selectedIds.value.length > 0) ; 
    const selectedIds = ref([])
    const selectedPaymentTotal = ref(0)
    const selectAll = ref(false);

    const statusOptions = [
      {id:1,label:'Ödendi'},
      {id:0,label:'Ödenmedi'}
    ]

    const rowClass = (item) => {
      if(item){
        return item.selected ? 'selected-row' : '';
      }
    }

    const updateSelection = (id, isSelected) => {
      if (isSelected) {
        selectedIds.value.push(id);
      } else {
        const index = selectedIds.value.indexOf(id);
        if (index > -1) {
          selectedIds.value.splice(index, 1);
        }
      }

      // ✅ Toplam ödemeyi yeniden hesapla
      selectedPaymentTotal.value = orderData.value
        .filter(item => selectedIds.value.includes(item.id))
        .reduce((sum, item) => sum + Number(item.inf_payment_total || 0), 0);

      // ✅ Tüm seçili kontrolü
      if (selectedIds.value.length == orderData.value.filter(item => !item.payment_status).length) {
        selectAll.value = true;
      } else {
        selectAll.value = false;
      }
    };

    const toggleAllSelections = () => {
      orderData.value.filter(item=>!item.payment_status).forEach((item) => {
        item.selected = selectAll.value; // Tüm öğelerin seçili durumunu `selectAll` ile eşle
      });
      updateSelectedIds(); // selectedIds değerini güncelle
    };

    const updateSelectedIds = () => {
      selectedIds.value = orderData.value
        .filter((item) => item.selected)
        .map((item) => item.id);

      // ✅ Toplamı da burada güncelle
      selectedPaymentTotal.value = orderData.value
        .filter(item => item.selected)
        .reduce((sum, item) => sum + Number(item.inf_payment_total || 0), 0);
    };


    const vestingDay = (created_date, periyod, order_status_id) => {
      const nowDate = new Date();
      const createdDate = new Date(created_date);

      // Saatleri sıfırla (Yalnızca günü hesaba kat)
      nowDate.setHours(0, 0, 0, 0);
      createdDate.setHours(0, 0, 0, 0);

      const vestingDate = new Date(createdDate);
      vestingDate.setDate(createdDate.getDate() + periyod);

      // Saat farkını sıfırladığımız için tam gün farkı doğru hesaplanacak
      const diffTime = vestingDate.getTime() - nowDate.getTime();
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      if (order_status_id === 2) {
          return diffDays <= 0 ? "Bekleniyor" : `${diffDays} gün kaldı`;
      }

      return diffDays > 0 ? `${diffDays} gün kaldı` : "Teslim edilmemiş";
    };



    const clearSelectedId = () => {
      selectedIds.value=[]
      orderData.value.forEach((item) => {
          item.selected = false; // Her bir item'in selected değerini false yap
      });
      selectAll.value=false
    }
    
    const paySelectedOrders = async () => {
      const updateData = selectedIds.value.map(id => ({
            id: id,
            payment_status: true,
        }));
      const response = await axiosIns.put('/order/update', updateData);
      if(response.data.success){
          toast({
            component: ToastificationContent,
              position: 'bottom-right',
              props: {
              icon: 'CheckIcon',
              variant: 'success',
              title: response.data.message,
            },
          });
          //Yeniden istek yapılsın diye...
          additionalParams.value = { ...props.params };
          selectAll.value=false
          selectedIds.value = []; // Seçimleri sıfırla
      }else{

        toast({
            component: ToastificationContent,
              position: 'bottom-right',
              props: {
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              title: response.data.message,
            },
          });
      }
    };

    const roleOptions = [
      { label: 'Admin', value: 'admin' },
      { label: 'Author', value: 'author' },
      { label: 'Editor', value: 'editor' },
      { label: 'Maintainer', value: 'maintainer' },
      { label: 'Subscriber', value: 'subscriber' },
    ];

    const planOptions = [
      { label: 'Basic', value: 'basic' },
      { label: 'Company', value: 'company' },
      { label: 'Enterprise', value: 'enterprise' },
      { label: 'Team', value: 'team' },
    ];

    const {
      orderData,
      updateOrderStatus,
      orderStatus,
      tableColumns: defaultTableColumns,
      perPage,
      currentPage,
      totalOrders,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refOrderListTable,

      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveOrderstatusVariant,

      roleFilter,
      planFilter,
      statusFilter,
      additionalParams

    } = useOrdersList();

    additionalParams.value = { ...props.params };
    
    watch(() => props.params, async (newParams) => {
        additionalParams.value = { ...newParams };  
    }, { deep: true });

    watch([orderData], () => {
      emit("orders-fetched", orderData.value);
      clearSelectedId();
    })

    const resolvedTableColumns = props.tableColumns || defaultTableColumns;
    
    return {
      rowClass,
      paySelectedOrders,
      toggleAllSelections,
      clearSelectedId,
      showToast,
      updateSelection,
      selectedPaymentTotal,

      selectAll,
      selectedIds,
      orderData,
      vestingDay,
      updateOrderStatus,
      resolvedTableColumns,
      orderStatus,
      perPage,
      currentPage,
      totalOrders,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refOrderListTable,

      avatarText,

      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveOrderstatusVariant,

      roleOptions,
      planOptions,
      statusOptions,

      roleFilter,
      planFilter,
      statusFilter,
      additionalParams,
    }
  },
}
</script>

<style lang="scss">
.selected-row {
  background-color: #d1e7dd !important; /* Açık yeşil arka plan */
}
.per-page-selector {
  width: 90px;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}
.per-page-selector {
  width: 90px;
}
.fixed-bottom {
  margin-bottom: 4vw; /* Toast'ın alt kısımdaki yüksekliği */
}
.text-center {
  text-align: center; /* Yazıyı ortalamak için */
}
</style>